import React, { useState, useContext } from "react"
import styled from "styled-components"
import NavbarMenuSliderMain from "./navbar-menu-slider-main"
import NavbarMenuSliderItemMain from "./menu-slider-navbar/navbar-menu-slider-item-main"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import Habmburger from "./menu-slider-navbar/svgs/hamburger"
import { FLAG, PHONE_NUMBER, EU_COUNTRIES } from "@src/utils/constants/locale"
import { LocaleContext } from "@src/context/locale-context"

const IconHolder = styled.div`
  cursor: pointer;
  display: none;
  @media (max-width: 900px) {
    display: flex;
  }
`

const Item = styled(Link)`
  display: block;
  text-decoration: none;
  color: #272d37;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  padding: 0 16px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

const HelpSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 16px;
  padding-top: 24px;
  border-top: 1px solid #eceff3;
`

const HelpTitle = styled.div`
  color: #272d37;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`

const PhoneNumber = styled.a`
  color: #26383b;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-decoration: none;
  cursor: pointer;
`

const UserSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-top: 1px solid #eceff3;
`

const Username = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 16px;
  padding-top: 24px;
`

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
`

const Name = styled.span`
  color: #315254;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
`

const NavbarHamburgerMenu = ({
  items,
  user,
  setUserFlowMode,
  setShowUserModal,
  signout,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  let { country } = useContext(LocaleContext)

  if (EU_COUNTRIES.includes(country)) {
    country = "EU"
  }

  const flag = FLAG[country]
  const phoneNumber = PHONE_NUMBER[country]

  const handleSignout = event => {
    event.preventDefault()
    signout()
      .then(result => {
        console.log("signout result =>", result)
      })
      .catch(error => {
        console.log("signout error =>", error)
      })
  }

  const handleLoginClick = event => {
    event.preventDefault()
    setUserFlowMode("LOGIN")
    setShowUserModal(true)
  }

  const handleSignUpClick = event => {
    event.preventDefault()
    setUserFlowMode("SIGNUP")
    setShowUserModal(true)
  }

  return (
    <IconHolder>
      <span onClick={() => setIsOpen(0)}>
        <Habmburger />
      </span>
      <NavbarMenuSliderMain
        isOpen={isOpen === 0}
        setIsOpen={setIsOpen}
        backToindex={-1}
      >
        {items.map((item, index) => {
          return (
            <NavbarMenuSliderItemMain
              key={item.name}
              name={item.name}
              items={item.items}
              index={index + 1}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              spread={item.spread}
            />
          )
        })}
        <Item to={"/contact"}>Contact us</Item>
        {!user && (
          <>
            <span onClick={handleLoginClick}>
              <Item>Log in</Item>
            </span>
            <span onClick={handleSignUpClick}>
              <Item>Sign up</Item>
            </span>
          </>
        )}
        {user && (
          <UserSection>
            <Username>
              <Avatar
                src="https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
                alt="User Avatar"
              />
              <Name>{user.profile.displayName}</Name>
            </Username>
            <Item to={"/user/profile"}>My account</Item>
            <span onClick={handleSignout}>
              <Item>Log out</Item>
            </span>
          </UserSection>
        )}
        <HelpSection>
          <HelpTitle>Need help?</HelpTitle>
          {phoneNumber && (
            <PhoneNumber href={`tel:${phoneNumber}`}>
              {flag} {phoneNumber}
            </PhoneNumber>
          )}
        </HelpSection>
      </NavbarMenuSliderMain>
    </IconHolder>
  )
}

NavbarHamburgerMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  setUserFlowMode: PropTypes.func.isRequired,
  setShowUserModal: PropTypes.func.isRequired,
  user: PropTypes.object,
  signout: PropTypes.func.isRequired,
}
export default NavbarHamburgerMenu
